import React, { Component, Fragment } from 'react'
import { config } from 'config/config'
import {
  VEHICLE_TYPE,
  COOKIES,
  SYSTEM,
  COOKIE_NOTICE_TYPES,
} from 'utils/constants'
import {
  setCookie,
  generateSearchURL,
  parseSearchFilters,
  cleanString,
  sortArrayAlphabeticallyByObjKey,
  cleanArray,
  generateFilterLocationFromCookie,
  getQueryParameter,
  getCookieChannel,
  generateLocationLeftHand,
  setEventToLazyDispatch,
  getCookie,
  hasLocationInUrl,
  removeAccents,
  orderObjectKeys,
  getCurrentChannel,
  parseLocation,
  splitCityState,
  returnStateLong,
  onClientSide,
  sendDispatchEvent,
  getStandardRadius,
  hasPandora,
  userPiiLocation
} from '@/utils/utils'
import CurrencyFormat from 'react-currency-format'
import { fetchCategories } from 'ducks/categories'
import { fetchFiltersCarLocation } from 'ducks/filtersCarLocation'
import { fetchFiltersBikeLocation } from 'ducks/filtersBikeLocation'
import { fetchGeolocation } from 'ducks/geolocation'
import { fetchHotDeal } from 'ducks/hotDeal'
import { connect } from 'react-redux'
import Button from 'components/Button'
import Slide from 'components/Slide'
import NavBar from 'components/NavBar'
import Input from 'components/Input'
import NavItem from 'components/NavBar/NavItem'
import AutoComplete from 'components/AutoComplete'
import CarouselContainer from 'components/CarouselContainer'
import CardMake from 'components/CarouselContainer/CardMake'
import LastSearches from 'components/LastSearches'

import RangeSlider from 'components/RangeSlider'
import { isNullOrUndefined } from 'util'
import './Filters.scss'
import OpportunitiesFilters from '@/modern/components/OpportunitiesFilters'
import buildOportunitiesUrl from '@/modern/components/OpportunitiesFilters/buildOportunitiesUrl'

import { withCookieNotice } from '@/store/context/cookie-notice-context'
import { cookieCategoryIsActive } from '@/modern/utils/cookies'
import { hasSpecialFairActive } from '@/modern/utils/fairs'

import FilterContainer from './FilterContainer'
import FilterGroup from './FilterGroup'
import DynamicFilterGroup from './DynamicFilterGroup'

let standardRadius = 100
let isOfficialStore = false

let emptyFilters = {
  estadocidade: '',
  tipoveiculo: '',
  estado: '',
  cidade: '',
  localizacao: {
    latitude: undefined,
    longitude: undefined,
    raio: undefined,
  },
  newFilters: '',
  car: {
    anoate: '',
    anode: '',
    cilindrada: '',
    km: '',
    kmate: '',
    kmde: '',
    marca1: '',
    media: '',
    modelo1: '',
    palavrachave: '',
    precoate: '',
    precode: '',
    versao1: '',
    novos: false,
    usados: false,
    anunciante: [],
    atributos: [],
    blindado: [],
    cambio: [],
    carroceria: [],
    cor: [],
    finalplaca: [],
    opcionais: [],
    necessidade: [],
    feirao: [],
    idrevendedor: '',
    combustivel: [],
  },
  bike: {
    anoate: '',
    anode: '',
    ccate: '',
    ccde: '',
    cilindrada: '',
    km: '',
    kmate: '',
    kmde: '',
    marca1: '',
    modelo1: '',
    palavrachave: '',
    precoate: '',
    precode: '',
    novos: false,
    usados: false,
    alimentacao: [],
    anunciante: [],
    atributos: [],
    carroceria: [],
    cor: [],
    corsecundaria: [],
    media: '',
    motor: [],
    necessidade: [],
    feirao: [],
    numeromarcha: [],
    opcionais: [],
    partida: [],
    refrigeracao: [],
    tipofreio: [],
    idrevendedor: '',
  },
}
let fetchTimeout

class Filters extends Component {
  constructor(props) {
    super(props)
    const { cookieNoticeContext } = this.props
    const { cookies } = cookieNoticeContext

    this.cookiesState = {
      channel: cookieCategoryIsActive(cookies, COOKIES.CHANNEL),
    }

    const constFilters = JSON.parse(JSON.stringify(emptyFilters))
    constFilters.tipoveiculo = this.props.initialFilters.lastType
      ? this.props.initialFilters.lastType
      : this.props.vehicleType
      ? this.props.vehicleType
      : VEHICLE_TYPE.car


    this.state = {
      hideCarDeliveryFilter: false,
      modelsOpen: false,
      versionsOpen: false,
      makesOpen: false,
      disableSubmit: false,
      makesCardsOpen: false,
      numberOfVehicles: undefined,
      locationInputValue: '',
      hasLastSearchesVariant: null,
      cityState: [],
      carMakes: [],
      bikeMakes: [],
      filters: constFilters,
      makeInputValue: '',
      modelInputValue: '',
      openKeyboard: false,
      listFilters: [],
      parentScrollContainer: undefined,
      fetchingAllFilters: false,
      keepNewUsedChecked: false,
      firstRun: true,
      colorsSource: {
        car: { fetched: false, filters: [] },
        bike: { fetched: false, filters: [] },
      },
      secondaryColorSource: {
        bike: { fetched: false, filters: [] },
      },
      optionalsSource: {
        car: { fetched: false, filters: [] },
        bike: { fetched: false, filters: [] },
      },
      feiraoSource: {
        car: { fetched: false, filters: [] },
        bike: { fetched: false, filters: [] },
      },
      bodyTypeSource: {
        car: { fetched: false, filters: [] },
        bike: { fetched: false, filters: [] },
      },
      gearShiftsSource: {
        car: { fetched: false, filters: [] },
      },
      attributesSource: {
        car: { fetched: false, filters: [] },
        bike: { fetched: false, filters: [] },
      },
      sellerTypeSource: {
        car: { fetched: false, filters: [] },
        bike: { fetched: false, filters: [] },
      },
      needSource: {
        bike: { fetched: false, filters: [] },
        car: { fetched: false, filters: [] },
      },
      coolingTypeSource: {
        bike: { fetched: false, filters: [] },
      },
      chargeSource: {
        bike: { fetched: false, filters: [] },
      },
      brakeSource: {
        bike: { fetched: false, filters: [] },
      },
      engineSource: {
        bike: { fetched: false, filters: [] },
      },
      ignitionSource: {
        bike: { fetched: false, filters: [] },
      },
      shiftsSource: {
        bike: { fetched: false, filters: [] },
      },
      fuelSource: {
        car: { fetched: false, filters: [] },
      },
      carPlateSource: {
        car: { fetched: false, filters: [] },
      },
      min: 0,
      max: 200,
      minLimit: 0,
      maxLimit: 200,
      filtersModels: [],
    }

    this.inputFilterKeys = [
      'precode',
      'precoate',
      'anode',
      'anoate',
      'kmde',
      'kmate',
      'ccde',
      'ccate',
    ]

    this.handleOpen = this.handleOpen.bind(this)
    this.debounceTimeout = null;
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleDebounce = this.handleDebounce.bind(this);
  }
  componentDidMount() {
    var channel = this.cookiesState.channel && getCurrentChannel()

    if (
      channel === '' ||
      channel == SYSTEM.WEBMOTORS ||
      channel == SYSTEM.BLUCARROS ||
      channel == SYSTEM.JOINVILLECARROS ||
      channel == SYSTEM.FLORIPACARROS ||
      channel == SYSTEM.ITAJAICARROS
    )
      this.getGeolocation()

    const isLastSearchActive = onClientSide() &&
    window.localStorage.getItem(config.abTest.lastSearches.key) === 'true' || false

    if(onClientSide()) {
      const currentUrl = new URL(document.location.href);
      isOfficialStore = currentUrl.pathname.includes("lojaoficial");
      standardRadius = isOfficialStore ? 0 : 100;
    }

    if (isLastSearchActive) {
      this.setState({ hasLastSearchesVariant: isLastSearchActive });
    } else {
      this.setState({ hasLastSearchesVariant: null });
    }
    if (!this.props.categories.fetched) {
      this.props.dispatch(fetchCategories())
    }
    if (!this.props.hotDeal.fetched) {
      this.props.dispatch(fetchHotDeal())
    }
    this.setState({ firstTracking: true })
    setTimeout(
      function () {
        this.setState({ firstRun: false })
      }.bind(this),
      1
    )
  }
  static getDerivedStateFromProps(props, state) {
    if (props.closeBalloonFilterResult) {
      return {
        balloon: props.closeBalloonFilterResult,
      }
    }

    return null
  }
  componentDidUpdate(prevProps, prevState) {
    const { cookies } = this.props.cookieNoticeContext
    const isCookieCategoryActive = cookieCategoryIsActive(
      cookies,
      COOKIES.TRACKING_FROM
    )

    const { filters } = this.state
    const prevFilters = prevState.filters || {}
    if (this.state.filters && this.state.filters.tipoveiculo) {
      if (this.state.filters.tipoveiculo != prevState.filters.tipoveiculo) {
        this.props.fetchLocationSearch(this.state.filters.tipoveiculo)
      }
      if (
        !this.state.fetchingAllFilters &&
        this.props.initialFilters != prevProps.initialFilters
      ) {
        this.setInitialFilters(true, this.props.initialFilters)
      }
      let type = this.state.filters.tipoveiculo
      if (this.state.filters[type].novos == this.state.filters[type].usados) {
        if (
          this.state.filters[type].novos == true &&
          !this.state.keepNewUsedChecked
        ) {
          this.setState({ keepNewUsedChecked: true })
        } else if (
          !this.state.filters[type].novos == true &&
          this.state.keepNewUsedChecked
        ) {
          this.setState({ keepNewUsedChecked: false })
        }
      }
      if (
        this.props.match.params &&
        prevProps.match &&
        prevProps.match.params &&
        JSON.stringify(this.props.match.params) !=
          JSON.stringify(prevProps.match.params)
      ) {
        setTimeout(
          function () {
            if (this.compareUrlToSelectedFilters()) {
              // em teoria só deve cair aqui quando fizer busca pela searchbar no topo
              this.refs.parentScrollContainer &&
                (this.refs.parentScrollContainer.scrollTop = 0)
              this.setInitialFilters(true, this.props.initialFilters)
            }
          }.bind(this),
          1
        )
      }

      if (
        this.props.filtersOpen != prevProps.filtersOpen &&
        this.props.filtersOpen == true
      ) {
        // quando menu estiver fechado e abrir
        setTimeout(
          function () {
            this.setInitialFilters(false, this.props.initialFilters)
          }.bind(this),
          1
        )
      }
      if (
        type != prevState.filters.tipoveiculo ||
        this.state.filters.estadocidade != prevState.filters.estadocidade ||
        JSON.stringify(prevFilters[type]) != JSON.stringify(filters[type]) ||
        this.state.filters[type].novos != prevState.filters[type].novos ||
        this.state.filters[type].usados != prevState.filters[type].usados ||
        (this.state.filters && this.state.filters.localizacao
          ? JSON.stringify(this.state.filters.localizacao)
          : undefined) !=
          (prevState && prevState.filters && prevState.filters.localizacao
            ? JSON.stringify(prevState.filters.localizacao)
            : undefined)
      ) {
        if (this.compareUrlToSelectedFilters()) {
          // verifica se os filtros selecionados mudaram mesmo, ou apenas a url refatorou e os filtros continuam iguais

          this.props.history.push('/' + this.handleFilterSubmit(type, true))

          const isTextInputFilter = this.inputFilterKeys.some(key =>
            this.state.filters[type][key] !== prevState.filters[type][key]
          )

          if (isCookieCategoryActive) {
            if (!isTextInputFilter)  {
              setEventToLazyDispatch('filtroRealizado')
            }
          }

          let fetchDelay = 500
          fetchTimeout && clearTimeout(fetchTimeout)
          fetchTimeout = setTimeout(
            function () {
              if (
                (this.state.filters[type].anode.trim().length == 0 ||
                  this.state.filters[type].anode.trim().length == 4) &&
                (this.state.filters[type].anoate.trim().length == 0 ||
                  this.state.filters[type].anoate.trim().length == 4)
              ) {
                this.setState({ numberOfVehicles: undefined }, () => {
                  this.fetchAllData(undefined, false)
                })
              }
            }.bind(this),
            fetchDelay
          )
        }
      }
      if (this.state.filters.estadocidade != prevState.filters.estadocidade) {
        // this.fetchAllMakes()
      }
    }

    if (this.state.balloon != prevState.balloon) {
      this.handleRemoveMake(this.state.balloon)
    }

    const oldCookies = prevProps.cookieNoticeContext.cookies

    if (
      JSON.stringify(oldCookies[COOKIE_NOTICE_TYPES.MARKETING]) !==
      JSON.stringify(cookies[COOKIE_NOTICE_TYPES.MARKETING])
    ) {
      this.cookiesState = {
        ...this.cookiesState,
        channel: cookieCategoryIsActive(cookies, COOKIES.CHANNEL),
      }
    }
  }
  getGeolocation() {
    if (onClientSide()) {
      const { cookies } = this.props.cookieNoticeContext
      const isCookieCategoryActive = cookieCategoryIsActive(
        cookies,
        COOKIES.GEOLOCATION
      )

      if (this.state.filters.estadocidade) {
        return false
      }

      let _geolocationCookie =
        isCookieCategoryActive && getCookie(COOKIES.GEOLOCATION)
      let _geolocationCookieParsed
      if (_geolocationCookie && _geolocationCookie.substring(0, 1) == '{') {
        _geolocationCookieParsed = JSON.parse(_geolocationCookie)
      } else {
        _geolocationCookieParsed = {
          estadocidade: '',
        }
      }
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          if (
            position &&
            position.coords &&
            position.coords.latitude &&
            position.coords.longitude
          ) {
            let data = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            }

            this.props.dispatch(fetchGeolocation(data)).then(result => {
              if (result && result.response) {
                const responseParsed = {
                  'edge-region': removeAccents(result.response['edge-region']).toLowerCase(),
                  'edge-region-full-name': removeAccents(returnStateLong(result.response['edge-region']).toLowerCase()),
                  'edge-city': result.response['edge-city']
                }

                if (!this.props.filtersCarLocation.fetched) {
                  this.props
                    .dispatch(
                      fetchFiltersCarLocation(config.urlApp)
                    )
                    .then(() => {
                      if (
                        this.props.filtersCarLocation.fetched &&
                        !this.props.filtersBikeLocation.fetched
                      ) {
                        this.props
                          .dispatch(
                            fetchFiltersBikeLocation(config.urlApp)
                          )
                          .then(() => {
                            this.getGeolocationParsed(
                              _geolocationCookieParsed,
                              responseParsed,
                              data
                            )
                          })
                      } else if (
                        this.props.filtersCarLocation.fetched &&
                        this.props.filtersBikeLocation.fetched
                      ) {
                        this.getGeolocationParsed(
                          _geolocationCookieParsed,
                          responseParsed,
                          data
                        )
                      }
                    })
                } else if (this.props.filtersCarLocation.fetched) {
                  if (!this.props.filtersBikeLocation.fetched) {
                    this.props
                      .dispatch(
                        fetchFiltersBikeLocation(config.urlApp)
                      )
                      .then(() => {
                        this.getGeolocationParsed(
                          _geolocationCookieParsed,
                          responseParsed,
                          data
                        )
                      })
                  } else if (this.props.filtersBikeLocation.fetched) {
                    this.getGeolocationParsed(
                      _geolocationCookieParsed,
                      responseParsed,
                      data
                    )
                  }
                }
              }
            })
          }
        })
      }
    }
  }
  getGeolocationParsed(_geolocationCookieParsed, response, latlong) {
    const { cookies } = this.props.cookieNoticeContext
    const { hasLastSearchesVariant  } = this.state

    const isCookieCategoryActive = cookieCategoryIsActive(
      cookies,
      COOKIES.FILTER_SEARCH
    )


    const isGeolocationCategoryActive = cookieCategoryIsActive(
      cookies,
      COOKIES.GEOLOCATION
    )

    let location = this.props.locationSearchResult
    let _channel = this.cookiesState.channel && getCurrentChannel()
    for (let i = 0; i < location.length; i++) {
      if (
        removeAccents(location[i].name.toLowerCase().trim()) ===
        response['edge-region-full-name']
      ) {
        let _state = location[i].name
        for (let j = 0; j < location[i].items.length; j++) {
          if (
            removeAccents(location[i].items[j].name.toLowerCase().trim()) ===
            response['edge-city']
          ) {
            let _city = location[i].items[j].name
            _geolocationCookieParsed.estadocidade = _state + ' - ' + _city

            const cityStateUnformatted = `${response['edge-city']} - ${response['edge-region']}`
            const defaultStandardRadius = getStandardRadius({ name: cityStateUnformatted }, standardRadius)

            if (latlong && latlong.latitude && latlong.longitude) {
              _geolocationCookieParsed.localizacao = {
                latitude: latlong.latitude,
                longitude: latlong.longitude,
                raio:
                  _channel &&
                  (_channel == SYSTEM.JOINVILLECARROS ||
                    _channel == SYSTEM.FLORIPACARROS ||
                    _channel == SYSTEM.BLUCARROS ||
                    _channel == SYSTEM.ITAJAICARROS)
                    ? 200
                    : defaultStandardRadius,
              }
            }
            if (isGeolocationCategoryActive) {
              setCookie(
                COOKIES.GEOLOCATION,
                JSON.stringify(_geolocationCookieParsed)
              )
            }
            this.setState({
              geolocation: _geolocationCookieParsed,
              geolocationLatLong: {
                latitude:
                  latlong && latlong.latitude ? latlong.latitude : undefined,
                longitude:
                  latlong && latlong.longitude ? latlong.longitude : undefined,
                raio:
                  _channel &&
                  (_channel == SYSTEM.JOINVILLECARROS ||
                    _channel == SYSTEM.FLORIPACARROS ||
                    _channel == SYSTEM.BLUCARROS ||
                    _channel == SYSTEM.ITAJAICARROS)
                    ? 200
                    : defaultStandardRadius,
              },
            })
          }
        }
      }
    }
    this.handleGeolocationFilterReload()
  }

  handleGeolocationFilterReload() {
    if (!navigator || !navigator.geolocation) return

    navigator.geolocation.getCurrentPosition(position => {

      const { latitude, longitude } = position.coords || {}

      if (!latitude || !longitude) return

      this.applyLocationFilter()

    })
  }

  applyLocationFilter() {
    if (!onClientSide()) return

    const { cookies } = this.props.cookieNoticeContext
    const isCookieCategoryActive = cookieCategoryIsActive(
      cookies,
      COOKIES.GEOLOCATION
    )
    const geolocationCookie =
      isCookieCategoryActive && getCookie(COOKIES.GEOLOCATION)

    if (!isCookieCategoryActive) return
    if (!geolocationCookie) return

    const HAS_FORCED_LOCATION_KEY = 'shouldNotForceLocation'
    const APPLIED_LAT_LONG_KEY = 'latLongFilterApplied'

    const hasForcedLocation = window.sessionStorage.getItem(
      HAS_FORCED_LOCATION_KEY
    )
    const currentUrl = window.location.href;
    const hasLocationFiltersInURL = hasLocationInUrl(currentUrl)
    const hasAppliedByIP = window.sessionStorage.getItem(
      'filterLocationApplyByIP'
    )

    if (hasForcedLocation || (hasLocationFiltersInURL && !hasAppliedByIP)) {
      return false
    }

    const parsedCookie = JSON.parse(geolocationCookie)
    const { estadocidade = '', localizacao = '' } = parsedCookie

    const { filters } = this.state
    const { estadocidade: filterLocation = '' } = filters || {}

    if (
      filterLocation !== '' &&
      filterLocation !== 'estoque' &&
      !hasAppliedByIP
    ) {
      return false
    }

    const searchParams = new URLSearchParams(document.location.search)

    if (estadocidade.split(' - ').length < 2) return false

    searchParams.set('estadocidade', estadocidade)
    const defaultRadius = isOfficialStore ? '0km' : '100km'

    const { latitude, longitude } = localizacao || {}
    const latLong =
      latitude && longitude ? `${latitude},${longitude}x${defaultRadius}` : ''

    if (latLong) {
      searchParams.set('localizacao', latLong)
    }

    let customParams = ''
    for (const [key, value] of searchParams) {
      if (customParams.length > 0) customParams += '&'
      customParams += `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    }

    this.props.history.push({ search: customParams })

    window.sessionStorage.removeItem('filterLocationApplyByIP')
    window.sessionStorage.setItem(APPLIED_LAT_LONG_KEY, 'true')
    userPiiLocation()
  }

  setInitialFilters(fetchAll, initialFilters) {
    if (initialFilters && initialFilters.lastType) {
      let newFilters = JSON.parse(JSON.stringify(emptyFilters))
      initialFilters.car &&
        (newFilters.car = Object.assign(
          newFilters.car,
          this.parseInitialFilterObj(initialFilters.car)
        ))
      initialFilters.bike &&
        (newFilters.bike = Object.assign(
          newFilters.bike,
          this.parseInitialFilterObj(initialFilters.bike)
        ))
      initialFilters.lastType &&
        initialFilters.lastType.includes('car') &&
        (newFilters.tipoveiculo = VEHICLE_TYPE.car)
      initialFilters.lastType &&
        initialFilters.lastType.includes('bike') &&
        (newFilters.tipoveiculo = VEHICLE_TYPE.bike)

      if (initialFilters.estadocidade) {
        let locationValue = generateFilterLocationFromCookie(
          decodeURIComponent(initialFilters.estadocidade)
        )
        newFilters.estadocidade = locationValue
        this.setState({ locationInputValue: locationValue })
      } else {
        newFilters.estadocidade = emptyFilters.estadocidade
        this.setState({ locationInputValue: emptyFilters.estadocidade })
      }
      if (newFilters[initialFilters.lastType].localizacao) {
        newFilters.localizacao = parseLocation(
          newFilters[initialFilters.lastType].localizacao
        )
        if (
          newFilters.localizacao.raio / 50 !=
          parseInt(newFilters.localizacao.raio / 50)
        ) {
          newFilters.localizacao.raio =
            parseInt(newFilters.localizacao.raio / 50) * 50
        }
      }
      delete newFilters.car.localizacao
      delete newFilters.bike.localizacao
      this.setState({ filters: newFilters }, () => {
        if (fetchAll) {
          this.fetchAllData(undefined, true)
        }
      })
    }
  }
  parseInitialFilterObj(filters) {
    let vehicleCategory = undefined
    let hotDeal = undefined
    if (typeof filters == 'string') {
      filters = filters.split('?')
      if (!/\/$/.test(filters[0])) {
        filters[0] = filters[0] + '/'
      }
      filters = filters.join('?').split('/')
    }
    if (
      !/^(carros|carros-usados|carros-novos|motos|motos-usadas|motos-novas)$/.test(
        filters[0]
      )
    ) {
      if (filters[0] == 'ofertas' && filters[1] == 'feiroes') {
        if (this.props.hotDeal.fetched && this.props.hotDeal.result) {
          let _object = this.props.hotDeal.result.find(
            x => x.URL.toLowerCase().trim() == filters[2].toLowerCase().trim()
          )
          if (_object && _object.Name) {
            hotDeal = _object.Name
          }
        }
        filters.splice(0, 3)
      } else {
        vehicleCategory = filters.shift()
        if (this.props.categories.fetched && this.props.categories.result) {
          let _object = this.props.categories.result.find(
            x =>
              x.Url.toLowerCase().trim() == vehicleCategory.toLowerCase().trim()
          )
          if (_object && _object.Nome) {
            vehicleCategory = _object.Nome
          }
        }
      }
    }

    let vehicleType = filters.shift() || 'carros'
    filters = filters.join('/')
    filters = filters.split('?')
    filters = parseSearchFilters(
      filters[0],
      filters[1] ? filters[1] : '',
      vehicleType,
      vehicleCategory,
      hotDeal
    )
    let locationInputValue
    filters.estadocidade && delete filters.estadocidade

    if (vehicleType.includes('nov')) {
      filters.novos = true
    } else if (vehicleType.includes('usad')) {
      filters.usados = true
    } else {
      filters.novos = this.state.keepNewUsedChecked
      filters.usados = this.state.keepNewUsedChecked
    }
    Object.keys(filters).forEach(function (key) {
      typeof filters[key] == 'string' &&
        (filters[key] = decodeURIComponent(filters[key].trim()))
    })
    delete filters.tipoveiculo
    delete filters.estadocidade
    return filters
  }
  checkInvert(filterFrom, filterTo) {
    let type = this.state.filters.tipoveiculo
    if (
      this.checkFieldValidity(
        filterFrom,
        this.state.filters[type][filterFrom]
      ) &&
      this.checkFieldValidity(filterTo, this.state.filters[type][filterTo]) &&
      parseInt(this.state.filters[type][filterFrom]) >
        parseInt(this.state.filters[type][filterTo])
    ) {
      let valueFrom = this.state.filters[type][filterFrom]
      let valueTo = this.state.filters[type][filterTo]
      setTimeout(() => {
        this.handleFilterChange(filterFrom, valueTo, type)
        this.handleFilterChange(filterTo, valueFrom, type)
      }, 0)
    }
  }
  checkFieldValidity(filter, value) {
    switch (filter) {
      case 'anode':
      case 'anoate':
        const isValidNumber = !Number.isNaN(parseInt(value))
        const is4DigitsLong = value.trim().length === 4
        const isValidYear = isValidNumber && is4DigitsLong

        return isValidYear
    }
    return !!value.trim().length
  }
  fetchAllData(filterUrl, setInitial, reTry) {
    let vehicleType = VEHICLE_TYPE[this.state.filters.tipoveiculo.toLowerCase()]
    !filterUrl &&
      (filterUrl = encodeURIComponent(
        config.urlApp + this.handleFilterSubmit()
      ))
    if (
      this.state.fetchingAllFilters ||
      (this.props.allFilters.fetched &&
        this.props.allFilters.requested &&
        this.props.allFilters.requested.url == filterUrl &&
        !this.state.firstRun)
    ) {
      return false
    }
    if (
      (vehicleType == 'car' &&
        !/\/(motos(\-novas)?(\-usadas)?)/.test(decodeURIComponent(filterUrl)) &&
        !decodeURIComponent(filterUrl).includes('tipoveiculo=motos')) ||
      (vehicleType == 'bike' &&
        !/\/(carros(\-novos)?(\-usados)?)/.test(
          decodeURIComponent(filterUrl)
        ) &&
        !decodeURIComponent(filterUrl).includes('tipoveiculo=carros'))
    ) {
      this.setState({ fetchingAllFilters: true }, () => {
        if (this.props.allFilters.length) {
          this.setState({ fetchingAllFilters: false, changingType: false })
          if (setInitial) {
            this.setInitialFilters(false, this.props.initialFilters)
          }
        }
      })
    }
  }
  fetchLocationLagLong(raio) {
    if (
      this.props.filtersCarLocation &&
      this.props.filtersCarLocation.result &&
      this.props.filtersBikeLocation &&
      this.props.filtersBikeLocation.result
    ) {
      let location = this.props.locationSearchResult
      let cityState = splitCityState(this.state.locationInputValue, true)
      for (let i = 0; i < location.length; i++) {
        if (location[i].name == cityState.state) {
          for (let ii = 0; ii < location[i].items.length; ii++) {
            if (
              removeAccents(location[i].items[ii].name.trim()) ==
              removeAccents(cityState.city.trim())
            ) {
              let geoCityState = location[i].items[ii]
              this.handleFilterChange('localizacao', {
                latitude: geoCityState.latitude
                  ? geoCityState.latitude
                  : undefined,
                longitude: geoCityState.longitude
                  ? geoCityState.longitude
                  : undefined,
                raio: raio
                  ? raio
                  : this.state.filters.localizacao &&
                    typeof this.state.filters.localizacao.raio == 'number'
                  ? this.state.filters.localizacao.raio
                  : standardRadius,
              })
            }
          }
        }
      }
    }
  }
  handleVehicleTypeChange(type) {
    this.setState({ changingType: true }, () => {
      if (type != this.state.filters.tipoveiculo) {
        this.handleFilterChange('tipoveiculo', type, type)
        this.props.vehicleTypeCallback && this.props.vehicleTypeCallback(type)
      }
    })
  }

  handleLocationFilterChange(newValues) {
    this.setState(prevState => {
      return {
        filters: { ...prevState.filters, ...newValues },
      }
    })
  }

  handleFilterChange(filter, value, type) {
    if (!type) {
      type = this.state.filters.tipoveiculo
    }
    let filters = JSON.parse(JSON.stringify(this.state.filters))

    if (typeof filter == 'string') {
      switch (filter) {
        case 'estadocidade':
        case 'tipoveiculo':
        case 'estado':
        case 'cidade':
        case 'localizacao':
        case 'newFilters':
          filters[filter] = value
          this.setState({ filters: { ...filters, [filter]: value } })
          break
        case 'blindado':
          if (!filters[type][filter].includes(value)) {
            filters[type][filter].push(value)
            filters[type][filter] = cleanArray(filters[type][filter])
          } else {
            let index = filters[type][filter].indexOf(value)
            delete filters[type][filter][index]
            filters[type][filter] = cleanArray(filters[type][filter])
          }
          this.setState({ filters: filters })
          break
        default:
          filters[type][filter] = value
          this.setState({ filters: filters })
          break
      }

      if (this.inputFilterKeys.includes(filter)) {
        this.handleDebounce(() => sendDispatchEvent('filtroRealizado'));
      }
    }
  }

  handleDebounce(callback = () => null, time = 3000) {
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(() => callback(), time);
  }

  handleFilterSubmit(type, useCustomization, handler, ignoreMakeModel) {
    let _cookieChannel = this.cookiesState.channel ? getCookieChannel() : ''

    const oportunitiesUrl = buildOportunitiesUrl(this.props.newFilters)
    const superSealOff = this.props.newFilters.superSealOff
      ? '&superSealOff=on'
      : ''

    !type && (type = this.state.filters.tipoveiculo)

    let filters = JSON.parse(JSON.stringify(this.state.filters))
    let order = getQueryParameter(this.props.location.search, 'o')
    let newFilters = {}

    Object.assign(filters, this.state.filters[type])

    delete filters.car
    delete filters.bike

    filters.tipoveiculo = type

    Object.keys(filters).forEach(function (key) {
      if (typeof filters[key] == 'string') {
        newFilters[key] = filters[key].trim()
      } else if (
        typeof filters[key] == 'number' ||
        typeof filters[key] == 'object' ||
        Array.isArray(filters[key])
      ) {
        newFilters[key] = filters[key]
      }
    })


    if (newFilters.tipoveiculo) {
      newFilters.tipoveiculo =
        VEHICLE_TYPE[newFilters.tipoveiculo.toUpperCase()]
      if (this.state.filters[type].novos != this.state.filters[type].usados) {
        newFilters.tipoveiculo == 'carros' &&
          this.state.filters[type].novos &&
          (newFilters.tipoveiculo += '-novos')
        newFilters.tipoveiculo == 'carros' &&
          this.state.filters[type].usados &&
          (newFilters.tipoveiculo += '-usados')
        newFilters.tipoveiculo == 'motos' &&
          this.state.filters[type].novos &&
          (newFilters.tipoveiculo += '-novas')
        newFilters.tipoveiculo == 'motos' &&
          this.state.filters[type].usados &&
          (newFilters.tipoveiculo += '-usadas')
      }
      //Adiciona os filtros de categorias e feirao
      if (
        handler &&
        this.state.filters[type].feirao.length == 0 &&
        this.props.match.params.hotDeal &&
        this.props.hotDeal &&
        this.props.hotDeal.result.length > 0
      ) {
        newFilters.feirao.push(
          this.props.hotDeal.result.find(
            x => x.URL == this.props.match.params.hotDeal
          ).Name
        )
      }
      if (
        handler &&
        this.state.filters[type].necessidade.length == 0 &&
        this.props.match.params.vehicleCategory &&
        this.props.categories &&
        this.props.categories.result.length > 0
      ) {
        newFilters.necessidade.push(
          this.props.categories.result.find(
            x => x.Url == this.props.match.params.vehicleCategory
          ).Nome
        )
      }
    }

    if (ignoreMakeModel) {
      delete newFilters.marca1
      delete newFilters.marca2
      delete newFilters.marca3
      delete newFilters.modelo1
      delete newFilters.modelo2
      delete newFilters.modelo3
      delete newFilters.versao1
      delete newFilters.versao2
      delete newFilters.versao3
    }

    if (order) {
      newFilters.o = order
    }

    !this.checkFieldValidity('anode', newFilters.anode) &&
      delete newFilters.anode
    !this.checkFieldValidity('anoate', newFilters.anoate) &&
      delete newFilters.anoate

    let route = generateSearchURL(newFilters)

    if (
      useCustomization &&
      this.state.filters &&
      this.state.filters[this.state.filters.tipoveiculo] &&
      this.state.filters[this.state.filters.tipoveiculo].feirao.length == 1 &&
      !isNullOrUndefined(
        this.state.filters[this.state.filters.tipoveiculo].feirao[0]
      ) &&
      this.props.hotDeal.fetched
    ) {
      for (let i = 0; i < this.props.hotDeal.result.length; i++) {
        if (
          this.props.hotDeal.result[i].Name.toLowerCase() ==
          this.state.filters[
            this.state.filters.tipoveiculo
          ].feirao[0].toLowerCase()
        ) {
          route = `${route}${_cookieChannel ? '&origem=' + _cookieChannel : ''}`
          return `ofertas/feiroes/${this.props.hotDeal.result[i].URL}/${route}${oportunitiesUrl}${superSealOff}`
        }
      }
    } else if (
      useCustomization &&
      this.state.filters &&
      this.state.filters[this.state.filters.tipoveiculo] &&
      this.state.filters[this.state.filters.tipoveiculo].necessidade.length ==
        1 &&
      !isNullOrUndefined(
        this.state.filters[this.state.filters.tipoveiculo].necessidade[0]
      ) &&
      this.props.categories.fetched
    ) {
      for (let i = 0; i < this.props.categories.result.length; i++) {
        if (
          this.props.categories.result[i].Nome.toLowerCase() ==
          this.state.filters[
            this.state.filters.tipoveiculo
          ].necessidade[0].toLowerCase()
        ) {
          route = `${route}${_cookieChannel ? '&origem=' + _cookieChannel : ''}`
          return `${this.props.categories.result[i].Url}/${route}${oportunitiesUrl}${superSealOff}`
        }
      }
    }
    route =
      route +
      (_cookieChannel ? `&origem=${_cookieChannel}` : '') +
      oportunitiesUrl +
      superSealOff
    return route
  }
  handleToggleModels(i) {
    if (!i || !i.match(/^(1|2|3)$/)) {
      this.setState({ modelsOpen: false, modelInputValue: '' })
    } else {
      this.setState({ modelsOpen: i })
    }
  }
  handleToggleVersions(i) {
    if (
      !i ||
      !i.match(/^(1|2|3)$/) ||
      !this.state.filters[this.state.filters.tipoveiculo]['modelo' + i]
    ) {
      this.setState({ versionsOpen: false, versionInputValue: '' })
    } else {
      this.setState({ versionsOpen: i })
    }
  }
  handleToggleAllMakes(state) {
    this.setState({
      makeInputValue: '',
      makesOpen: state || !this.state.makesOpen,
    })
  }
  handleAddMake(make, e) {
    let marca = 'marca1'
    this.state.filters[this.state.filters.tipoveiculo].marca1 &&
      (marca = 'marca2')
    this.state.filters[this.state.filters.tipoveiculo].marca2 &&
      (marca = 'marca3')
    this.state.filters[this.state.filters.tipoveiculo].marca3 && (marca = false)
    this.handleFilterChange(marca, make)
    this.setState({ makesOpen: false, makesCardsOpen: false })
    if(e && e.preventDefault) {
      e.preventDefault()
    }
  }
  handleAddModel(model, e) {
    if (this.state.modelsOpen && model) {
      this.handleFilterChange('modelo' + this.state.modelsOpen, model)
    }
    this.handleToggleModels(false)
    e.preventDefault()
  }
  handleAddVersion(version, e) {
    if (this.state.versionsOpen && version) {
      this.handleFilterChange('versao' + this.state.versionsOpen, version)
    }
    this.handleToggleVersions(false)
    e.preventDefault()
  }
  handleRemoveMake(item, makeNumber) {
    let type = this.state.filters.tipoveiculo
    let filtersObj = JSON.parse(JSON.stringify(this.state.filters[type]))
    let _keyMaker = Object.keys(filtersObj).find(key => filtersObj[key] == item)
    if (
      filtersObj.marca1 === filtersObj.marca2 ||
      filtersObj.marca1 === filtersObj.marca3 ||
      filtersObj.marca2 === filtersObj.marca3
    ) {
      _keyMaker = _keyMaker.slice(0, 5) + makeNumber
    }
    if (_keyMaker && _keyMaker.match(/marca/g)) {
      let _index = _keyMaker.split('marca')
      _index = _index[1]
      this.setState({ makesCardsOpen: false })
      filtersObj['marca' + _index] = ''
      filtersObj['modelo' + _index] = ''
      filtersObj['versao' + _index] = ''
      for (let i = 1; i < 3; i++) {
        if (!filtersObj['marca' + i] && filtersObj['marca' + (i + 1)]) {
          filtersObj['marca' + i] = filtersObj['marca' + (i + 1)]
          filtersObj['marca' + (i + 1)] = ''
          if (filtersObj['modelo' + (i + 1)]) {
            filtersObj['modelo' + i] = filtersObj['modelo' + (i + 1)]
            filtersObj['modelo' + (i + 1)] = ''
          }
          if (filtersObj['versao' + (i + 1)]) {
            filtersObj['versao' + i] = filtersObj['versao' + (i + 1)]
            filtersObj['versao' + (i + 1)] = ''
          }
        }
      }
      this.setState({
        filters: { ...this.state.filters, ...{ [type]: filtersObj } },
      })
    }
  }
  handleLocationResult(value, changeFilters) {
    let type = this.state.filters.tipoveiculo
    this.setState({ locationInputValue: value.name || value }, () => {
      if (changeFilters) {
        if(value) sendDispatchEvent("edicaoCampoLocalizacaoRB")

        const [cidade = '', estado = ''] = (value.name || value).split(' - ')

        const defaultStandardRadius = getStandardRadius(
          { name: value.name || value || '' },
          standardRadius
        )

        const localizacao = {
          latitude: value && (value.latitude || value.Latitude),
          longitude: value && (value.longitude || value.Longitude),
          raio: defaultStandardRadius,
        }

        const newValues = {
          estadocidade: value.name || value,
          cidade,
          estado,
          localizacao,
        }

        this.handleLocationFilterChange(newValues)
      }
    })
  }
  checkYearField() {
    let type = this.state.filters.tipoveiculo
    if (!this.checkFieldValidity('anode', this.state.filters[type].anode)) {
      setTimeout(() => {
        this.handleFilterChange('anode', '', type)
      }, 0)
    }
    if (!this.checkFieldValidity('anoate', this.state.filters[type].anoate)) {
      setTimeout(() => {
        this.handleFilterChange('anoate', '', type)
      }, 0)
    }
    this.checkInvert('anode', 'anoate')
  }
  renderToolTipGeolocation() {
    if (
      this.state.filters.estadocidade &&
      this.state.filters.estadocidade !== 'estoque'
    ) {
      return ''
    }

    if (this.state.geolocation) {
      let _value = generateFilterLocationFromCookie(
        decodeURIComponent(this.state.geolocation.estadocidade)
      )
      return (
        <button
          className="tooltip_arrow_box"
          onClick={this.handleGeolocationFilter.bind(this, _value)}
        >
          Você está em <strong>{_value}</strong>?
        </button>
      )
    }
  }
  handleGeolocationFilter(_value) {
    let _channel = this.cookiesState.channel && getCurrentChannel()
    this.setState({ locationInputValue: _value }, () => {})
    this.handleFilterChange('estadocidade', _value)
    if (
      this.state.geolocationLatLong &&
      this.state.geolocationLatLong.latitude &&
      this.state.geolocationLatLong.longitude
    ) {
      const defaultStandardRadius = getStandardRadius(
        { name: _value || '' },
        standardRadius
      )
      setTimeout(() => {
        this.handleFilterChange('localizacao', {
          latitude: this.state.geolocationLatLong.latitude || undefined,
          longitude: this.state.geolocationLatLong.longitude || undefined,
          raio:
            _channel &&
            (_channel == SYSTEM.JOINVILLECARROS ||
              _channel == SYSTEM.FLORIPACARROS ||
              _channel == SYSTEM.BLUCARROS ||
              _channel == SYSTEM.ITAJAICARROS)
              ? 200
              : defaultStandardRadius,
        })
      }, 0)
    }
  }
  handleSliderChange(min, max) {
    let location = JSON.parse(JSON.stringify(this.state.filters.localizacao))
    if (!location || !location.latitude || !location.longitude) {
      this.fetchLocationLagLong(max)
    } else {
      location.raio = max
      this.handleFilterChange('localizacao', location)
    }
  }

  addUrl = () => {
    if (typeof window !== 'undefined') {
      const filters = this.props.newFilters
      const search = window.location.search
      .replace(/&?Oportunidades=|Super%20Preco|Car%20Delivery|Troca%20Com%20Troco|Vis%C3%A3o360%C2%B0|Vistoriado&?|\|/g, '');

      const finalUrl = search + buildOportunitiesUrl(filters)

      this.props.history.push({ search: finalUrl })
    }
  }

  shouldShowOffersOnTop() {
    const { hasBlackFair, hasMegaFair } = this.props.fairs
    const { result, fetched } = this.props.searchResult

    const hotdeal =
      fetched && result.Filters.find(filter => filter.name === 'HotDeal')
    const hasHotdeals = hotdeal && hotdeal.items && hotdeal.items.length > 0

    const showOnTop =
      hasSpecialFairActive(hasMegaFair, hasBlackFair) && hasHotdeals

    return showOnTop
  }
  getLastSearchCookies() {
    const { cookies } = this.props.cookieNoticeContext
    const isCookieCategoryActive = cookieCategoryIsActive(
      cookies,
      COOKIES.LAST_SEARCHES
    )

    if (isCookieCategoryActive) {
      const _searchCookie = getCookie(COOKIES.LAST_SEARCHES)
      return typeof _searchCookie === 'string'
        ? JSON.parse(_searchCookie)
        : undefined
    }
    clearCookie(COOKIES.LAST_SEARCHES)

    return undefined
  }
  renderFilters() {
    const { cookies } = this.props.cookieNoticeContext
    const  lastSearchesData = this.state.hasLastSearchesVariant && this.getLastSearchCookies()
    if (this.state.filters.tipoveiculo) {
      return (
        <form autoComplete="off">
          <FilterGroup title="Localização">
            <AutoComplete
              dataQA="input_location_auto_complete"
              responsive={{ mobileVersion: true, browser: 'chrome' }}
              source={this.props.locationSearchResult}
              placeholder={'Digite seu estado ou cidade'}
              vehicleRoute={'carros'}
              disabled={false}
              callBack={this.handleLocationResult.bind(this)}
              value={this.state.locationInputValue}
              lastValid={this.state.filters.estadocidade}
              id="locationAutoComplete"
              blankResult=""
              parentScrollContainer={
                this.refs.parentScrollContainer
                  ? this.refs.parentScrollContainer
                  : undefined
              }
            />
            {this.renderToolTipGeolocation()}
          </FilterGroup>
          {splitCityState(this.state.locationInputValue).city &&
          this.props.filtersCarLocation &&
          this.props.filtersBikeLocation &&
          this.state.filters.localizacao &&
          this.state.filters.localizacao.latitude &&
          this.state.filters.localizacao.longitude ? (
            <FilterGroup title="Aumente o alcance da busca">
              <div className="Form__InputRow">
                <RangeSlider
                  minLimit={this.state.minLimit}
                  maxLimit={this.state.maxLimit}
                  singleSlider={true}
                  minRange={0}
                  min={0}
                  max={
                    this.state.filters.localizacao &&
                    !isOfficialStore &&
                    typeof this.state.filters.localizacao.raio == 'number'
                      ? this.state.filters.localizacao.raio
                      : standardRadius
                  }
                  handleChange={(min, max) => this.handleSliderChange(min, max)}
                  step={50}
                  responsive={{ mobileVersion: true, browser: 'chrome' }}
                />
              </div>
              <ul className="range-limit">
                <li
                  onClick={() => this.handleSliderChange(0, 0)}
                  className={
                    'range-limit__items' +
                    (0 <= this.state.filters.localizacao.raio ||
                    !this.state.filters.localizacao ||
                    !this.state.filters.localizacao.raio
                      ? ' range-limit__items--active'
                      : '')
                  }
                >
                  0km
                </li>
                <li
                  onClick={() => this.handleSliderChange(0, 50)}
                  className={
                    'range-limit__items' +
                    (50 <= this.state.filters.localizacao.raio
                      ? ' range-limit__items--active'
                      : '')
                  }
                >
                  50km
                </li>
                <li
                  onClick={() => this.handleSliderChange(0, 100)}
                  className={
                    'range-limit__items' +
                    (100 <= this.state.filters.localizacao.raio
                      ? ' range-limit__items--active'
                      : '')
                  }
                >
                  100km
                </li>
                <li
                  onClick={() => this.handleSliderChange(0, 150)}
                  className={
                    'range-limit__items' +
                    (150 <= this.state.filters.localizacao.raio
                      ? ' range-limit__items--active'
                      : '')
                  }
                >
                  150km
                </li>
                <li
                  onClick={() => this.handleSliderChange(0, 200)}
                  className={
                    'range-limit__items' +
                    (200 <= this.state.filters.localizacao.raio
                      ? ' range-limit__items--active'
                      : '')
                  }
                >
                  200km
                </li>
              </ul>
            </FilterGroup>
          ) : undefined}
          {this.state.hasLastSearchesVariant && lastSearchesData ?
            <FilterGroup  title="Suas últimas buscas">
              <LastSearches
                source={this.getLastSearchCookies()}
                title=""
                maxOptionals={1}
                id="CarouselLastSearches"
                lastSearchCookies={lastSearchesData}
              />
            </FilterGroup> : null}
          {this.shouldShowOffersOnTop() && this.renderHotDeal()}

          <OpportunitiesFilters
            filterChange={this.props.handleNewFilterChange}
            vehicleType={this.props.vehicleType}
            showSearchPlaceholder={this.props.beginSearchLoad}
            addUrl={this.addUrl}
            categoryCookieActive={cookieCategoryIsActive(
              cookies,
              COOKIES.LAST_SEARCHES
            )}
          />

          <FilterGroup
            title={
              this.state.filters.tipoveiculo == VEHICLE_TYPE.car
                ? 'Marca do carro'
                : 'Marca da moto'
            }
          >
            {this.renderCurrentMakes()}
            {this.renderAddMake()}
          </FilterGroup>
          <FilterGroup
            title={
              this.state.filters.tipoveiculo == VEHICLE_TYPE.bike
                ? 'Motos'
                : 'Carros'
            }
          >
            <div className="Form__InputRow">
              <label data-qa="filter_vehicle_new" className="Checkbox">
                <input
                  type="checkbox"
                  name="novos"
                  id="novos"
                  checked={
                    this.state.filters[this.state.filters.tipoveiculo].novos
                  }
                  className="Form__TextInput"
                  onChange={event => {
                    this.handleFilterChange('novos', event.target.checked)
                  }}
                />
                {this.state.filters.tipoveiculo == VEHICLE_TYPE.bike
                  ? 'Novas'
                  : 'Novos'}
              </label>
              <label data-qa="filter_vehicle_used" className="Checkbox">
                <input
                  type="checkbox"
                  name="usados"
                  id="usados"
                  checked={
                    this.state.filters[this.state.filters.tipoveiculo].usados
                  }
                  className="Form__TextInput"
                  onChange={event => {
                    this.handleFilterChange('usados', event.target.checked)
                  }}
                />
                {this.state.filters.tipoveiculo == VEHICLE_TYPE.bike
                  ? 'Usadas'
                  : 'Usados'}
              </label>
            </div>
          </FilterGroup>
          <FilterGroup title="Ano">
            <div className="Form__InputRow">
              <div className="Form__field">
                <CurrencyFormat
                  data-qa="field_year_from"
                  name="anode"
                  ref="anode"
                  value={
                    this.state.filters[this.state.filters.tipoveiculo].anode
                  }
                  className={
                    'Form__field__noerror ' +
                    (this.state.filters[this.state.filters.tipoveiculo].anode
                      ? ' Form__field__filled'
                      : '')
                  }
                  onChange={event => {
                    this.handleFilterChange('anode', event.target.value)
                  }}
                  onBlur={this.checkYearField.bind(this)}
                  thousandSeparator=""
                  decimalSeparator=","
                  type="tel"
                  format="####"
                />
                <label className="Form__field__label">de</label>
                <div className="Form__field__example">ex.: 2014</div>
              </div>
              <div className="Form__field">
                <CurrencyFormat
                  data-qa="field_year_to"
                  name="anoate"
                  ref="anoate"
                  value={
                    this.state.filters[this.state.filters.tipoveiculo].anoate
                  }
                  className={
                    'Form__field__noerror ' +
                    (this.state.filters[this.state.filters.tipoveiculo].anoate
                      ? ' Form__field__filled'
                      : '')
                  }
                  onChange={event => {
                    this.handleFilterChange('anoate', event.target.value)
                  }}
                  onBlur={this.checkYearField.bind(this)}
                  thousandSeparator=""
                  decimalSeparator=","
                  type="tel"
                  format="####"
                />
                <label className="Form__field__label">até</label>
                <div className="Form__field__example">ex.: 2019</div>
              </div>
            </div>
          </FilterGroup>
          <FilterGroup title="Preço">
            <div className="Form__InputRow">
              <div className="Form__field">
                <CurrencyFormat
                  data-qa="field_price_from"
                  name="precode"
                  ref="precode"
                  value={
                    this.state.filters[this.state.filters.tipoveiculo].precode
                  }
                  className={
                    'Form__field__noerror ' +
                    (this.state.filters[this.state.filters.tipoveiculo].precode
                      ? ' Form__field__filled'
                      : '')
                  }
                  onChange={event => {
                    this.handleFilterChange(
                      'precode',
                      event.target.value.replace(/[^0-9]/g, '')
                    )
                  }}
                  onBlur={this.checkInvert.bind(this, 'precode', 'precoate')}
                  prefix={'R$ '}
                  thousandSeparator="."
                  decimalSeparator=","
                  type="tel"
                />
                <label className="Form__field__label">de</label>
                <div className="Form__field__example">ex.: 20.000</div>
              </div>
              <div className="Form__field">
                <CurrencyFormat
                  data-qa="field_price_to"
                  name="precoate"
                  ref="precoate"
                  value={
                    this.state.filters[this.state.filters.tipoveiculo].precoate
                  }
                  className={
                    'Form__field__noerror ' +
                    (this.state.filters[this.state.filters.tipoveiculo].precoate
                      ? ' Form__field__filled'
                      : '')
                  }
                  onChange={event => {
                    this.handleFilterChange(
                      'precoate',
                      event.target.value
                        .replace(/[^0-9]/g, '')
                        .replace(/^0*/, '')
                    )
                  }}
                  onBlur={this.checkInvert.bind(this, 'precode', 'precoate')}
                  prefix={'R$ '}
                  thousandSeparator="."
                  decimalSeparator=","
                  type="tel"
                />
                <label className="Form__field__label">até</label>
                <div className="Form__field__example">ex.: 50.000</div>
              </div>
            </div>
          </FilterGroup>
          <FilterGroup title="Quilometragem">
            <div className="Form__InputRow">
              <div className="Form__field">
                <CurrencyFormat
                  data-qa="field_mileage_from"
                  name="kmde"
                  ref="kmde"
                  value={
                    this.state.filters[this.state.filters.tipoveiculo].kmde
                  }
                  className={
                    'Form__field__noerror ' +
                    (this.state.filters[this.state.filters.tipoveiculo].kmde
                      ? ' Form__field__filled'
                      : '')
                  }
                  onChange={event => {
                    this.handleFilterChange(
                      'kmde',
                      event.target.value
                        .replace(/[^0-9]/g, '')
                        .replace(/^0*/, '')
                    )
                  }}
                  onBlur={this.checkInvert.bind(this, 'kmde', 'kmate')}
                  prefix={''}
                  thousandSeparator="."
                  decimalSeparator=","
                  type="tel"
                />
                <label className="Form__field__label">de</label>
                <div className="Form__field__example">ex.: 10.000</div>
              </div>
              <div className="Form__field">
                <CurrencyFormat
                  data-qa="field_mileage_to"
                  name="kmate"
                  ref="kmate"
                  value={
                    this.state.filters[this.state.filters.tipoveiculo].kmate
                  }
                  className={
                    'Form__field__noerror ' +
                    (this.state.filters[this.state.filters.tipoveiculo].kmate
                      ? ' Form__field__filled'
                      : '')
                  }
                  onChange={event => {
                    this.handleFilterChange(
                      'kmate',
                      event.target.value
                        .replace(/[^0-9]/g, '')
                        .replace(/^0*/, '')
                    )
                  }}
                  onBlur={this.checkInvert.bind(this, 'kmde', 'kmate')}
                  prefix={''}
                  thousandSeparator="."
                  decimalSeparator=","
                  type="tel"
                />
                <label className="Form__field__label">até</label>
                <div className="Form__field__example">ex.: 50.000</div>
              </div>
            </div>
          </FilterGroup>
        </form>
      )
    }
    return false
  }
  hideCarDeliveryFilter = hide => {
    this.setState({ hideCarDeliveryFilter: hide })
  }
  renderDynamicFilterGroup({
    title,
    text,
    slideName,
    responseName,
    filterName,
    slideLeft,
    exclusiveVehicleType = this.state.filters.tipoveiculo,
    limit,
    dataQA = '',
  }) {
    if (
      !exclusiveVehicleType ||
      this.state.filters.tipoveiculo == exclusiveVehicleType
    ) {
      return (
        <DynamicFilterGroup
          slideLeftOpen={this.state['slideLeftOpen' + slideName]}
          filtersSource={this.getObjectFilter(responseName)}
          activeFilters={
            this.state.filters[this.state.filters.tipoveiculo][filterName]
          }
          handleOpen={e => this.handleOpen(e, slideName)}
          callBack={this.handleFilterChange.bind(this)}
          filterGroupName={filterName}
          title={title}
          text={text}
          vehicleType={
            exclusiveVehicleType
              ? exclusiveVehicleType
              : this.state.filters.tipoveiculo
          }
          limit={limit}
          dataQA={dataQA}
          hideCarDeliveryFilter={this.hideCarDeliveryFilter}
        />
      )
    }
  }
  renderAttributes() {
    return this.renderDynamicFilterGroup({
      title: 'Características',
      text: 'Ver todas as características',
      slideName: 'Atributos',
      responseName: 'VA',
      filterName: 'atributos',
      dataQA: 'filter_attribute'
    })
  }
  renderColors() {
    return this.renderDynamicFilterGroup({
      title:
        this.state.filters.tipoveiculo === 'bike' ? 'Cor primária' : 'Cores',
      text: 'Ver todas as cores',
      slideName: 'Cor',
      responseName: 'Color',
      filterName: 'cor',
      dataQA: 'filter_color'
    })
  }
  renderFuels() {
    return this.renderDynamicFilterGroup({
      title: 'Combustí­vel',
      text: 'Ver todos os combustíveis',
      slideName: 'Fuels',
      responseName: 'Fuel',
      filterName: 'combustivel',
      exclusiveVehicleType: VEHICLE_TYPE.car,
      dataQA: 'filter_fuel'
    })
  }
  renderGearshifts() {
    return this.renderDynamicFilterGroup({
      title: 'Câmbio',
      text: 'Ver todos os câmbios',
      slideName: 'Gears',
      responseName: 'Transmission',
      filterName: 'cambio',
      exclusiveVehicleType: VEHICLE_TYPE.car,
      dataQA: 'filter_gear'
    })
  }
  renderOptionals() {
    return this.renderDynamicFilterGroup({
      title: 'Opcionais',
      text: 'Ver todos os opcionais',
      slideName: 'Opt',
      responseName: 'OP',
      filterName: 'opcionais',
      dataQA: 'filter_optional'
    })
  }
  renderBodyType() {
    return this.renderDynamicFilterGroup({
      title:
        this.state.filters.tipoveiculo == VEHICLE_TYPE.car
          ? 'Carroceria'
          : 'Estilo',
      text:
        this.state.filters.tipoveiculo == VEHICLE_TYPE.car
          ? 'Tipo de carroceria'
          : 'Ver todos os estilo',
      slideName:
        this.state.filters.tipoveiculo == VEHICLE_TYPE.car
          ? 'CarBody'
          : 'MotoBody',
      responseName: 'BodyType',
      filterName: 'carroceria',
      dataQA: 'filter_body_type'
    })
  }
  renderSeller() {
    return this.renderDynamicFilterGroup({
      title: 'Vendedor',
      text: '',
      responseName: 'SellerType',
      filterName: 'anunciante',
      limit: 10,
      dataQA: 'filter_seller'
    })
  }
  renderFinalPlate() {
    return this.renderDynamicFilterGroup({
      title: 'Final da Placa',
      text: '',
      responseName: 'FinalPlateCarGroupy',
      filterName: 'finalplaca',
      exclusiveVehicleType: VEHICLE_TYPE.car,
      limit: 10,
      dataQA: 'filter_final_plate'
    })
  }
  renderCylinderCapacity() {
    return (
      <FilterGroup title="Cilindradas">
        <div className="Form__InputRow">
          <div className="Form__field">
            <CurrencyFormat
              data-qa="field_engine_capacity_from"
              name="ccde"
              ref="ccde"
              value={this.state.filters.bike.ccde}
              className={
                'Form__field__noerror ' +
                (this.state.filters.bike.ccde ? ' Form__field__filled' : '')
              }
              onChange={event => {
                this.handleFilterChange(
                  'ccde',
                  event.target.value.replace(/[^0-9]/g, '').replace(/^0*/, '')
                )
              }}
              onBlur={this.checkInvert.bind(this, 'ccde', 'ccate')}
              prefix={''}
              thousandSeparator="."
              decimalSeparator=","
              type="tel"
            />
            <label className="Form__field__label">de</label>
            <div className="Form__field__example">ex.: 125</div>
          </div>
          <div className="Form__field">
            <CurrencyFormat
              data-qa="field_engine_capacity_to"
              name="ccate"
              ref="ccate"
              value={this.state.filters.bike.ccate}
              className={
                'Form__field__noerror ' +
                (this.state.filters.bike.ccate ? ' Form__field__filled' : '')
              }
              onChange={event => {
                this.handleFilterChange(
                  'ccate',
                  event.target.value.replace(/[^0-9]/g, '').replace(/^0*/, '')
                )
              }}
              onBlur={this.checkInvert.bind(this, 'ccde', 'ccate')}
              prefix={''}
              thousandSeparator="."
              decimalSeparator=","
              type="tel"
            />
            <label className="Form__field__label">até</label>
            <div className="Form__field__example">ex.: 1200</div>
          </div>
        </div>
      </FilterGroup>
    )
  }
  renderCoolingType() {
    return this.renderDynamicFilterGroup({
      title: 'Tipo de refrigeração',
      text: 'Ver todos os tipos',
      slideName: 'Cooling',
      responseName: 'Cooling',
      filterName: 'refrigeracao',
      exclusiveVehicleType: VEHICLE_TYPE.bike,
    })
  }
  renderIgnition() {
    return this.renderDynamicFilterGroup({
      title: 'Tipo de partida',
      text: 'Ver todos os tipos',
      slideName: 'Ignition',
      responseName: 'Starter',
      filterName: 'partida',
      exclusiveVehicleType: VEHICLE_TYPE.bike,
      dataQA: 'filter_ignition'
    })
  }
  renderEngine() {
    return this.renderDynamicFilterGroup({
      title: 'Tipo de motor',
      text: 'Ver todos os tipos',
      slideName: 'Engine',
      responseName: 'Engine',
      filterName: 'motor',
      exclusiveVehicleType: VEHICLE_TYPE.bike,
      dataQA: 'filter_engine'
    })
  }
  renderShifts() {
    return this.renderDynamicFilterGroup({
      title: 'Número de marchas',
      text: 'Ver todos os números',
      slideName: 'Shifts',
      responseName: 'Shift',
      filterName: 'numeromarcha',
      exclusiveVehicleType: VEHICLE_TYPE.bike,
      dataQA: 'filter_shifts'
    })
  }
  renderBrake() {
    return this.renderDynamicFilterGroup({
      title: 'Freio dianteiro / traseiro',
      text: 'Ver todos os freios',
      slideName: 'Brake',
      responseName: 'Break',
      filterName: 'tipofreio',
      exclusiveVehicleType: VEHICLE_TYPE.bike,
      dataQA: 'filter_break'
    })
  }
  renderCharge() {
    return this.renderDynamicFilterGroup({
      title: 'Tipo de alimentação',
      text: 'Ver todos os tipos',
      slideName: 'Charge',
      responseName: 'Charge',
      filterName: 'alimentacao',
      exclusiveVehicleType: VEHICLE_TYPE.bike,
      dataQA: 'filter_charge'
    })
  }
  renderSecondaryColor() {
    return this.renderDynamicFilterGroup({
      title: 'Cor secundária',
      text: 'Ver todas as cores',
      slideName: 'Color',
      responseName: 'ColorSecundary',
      filterName: 'corsecundaria',
      exclusiveVehicleType: VEHICLE_TYPE.bike,
      dataQA: 'filter_secondary_color',
    })
  }
  renderNeed() {
    return this.renderDynamicFilterGroup({
      title: 'Categoria',
      text: 'Ver todos os tipos',
      slideName: 'Need',
      responseName: 'LifeStyle',
      filterName: 'necessidade',
      dataQA: 'filter_needs',
    })
  }
  renderHotDeal() {
    return this.renderDynamicFilterGroup({
      title: 'Ofertas',
      text: 'Ver todas as ofertas',
      slideName: 'Feirao',
      responseName: 'HotDeal',
      filterName: 'feirao',
      dataQA: 'filter_hot_deal',
    })
  }
  renderVersions() {
    return (
      <Slide isOpen={this.state.versionsOpen} position={'Left'}>
        <FilterContainer title="Versões">
          <FilterGroup noBorder={true}>
            <Input
              label="Digite a versão desejada"
              type="text"
              value={this.state.versionInputValue}
              onChange={e => {
                this.setState({ versionInputValue: e.target.value })
              }}
              dontShowError={true}
            />
          </FilterGroup>
          <FilterGroup noBorder={true}>
            {this.renderVersionsBack()}
            {this.renderVersionsList()}
          </FilterGroup>
        </FilterContainer>
      </Slide>
    )
  }
  renderVersionsBack() {
    return (
      <div
        className="Filters__back"
        onClick={this.handleToggleVersions.bind(this, false)}
      ></div>
    )
  }

  renderVersionsList() {
    const { versionsOpen, filters } = this.state
    const openedVersion = versionsOpen ? versionsOpen - 1 : 0
    const type = filters.tipoveiculo
    const { marca1 = '', marca2 = '', marca3 = '', modelo1 = '', modelo2 = '', modelo3 = '', versao1 = '', versao2 = '', versao3 = '' } = filters[type];
    const makeSelected = [marca1, marca2, marca3].filter(Boolean);

    if (makeSelected.length === 0) return null;
    let filteredBrands = []

    filteredBrands = this.getObjectFilter('Make').filter(item => {
      return item.selected
    })

    if (filteredBrands.length !== makeSelected.length) {
      filteredBrands = makeSelected.map(selectedBrand => {
        return this.getObjectFilter('Make').find((brand = {}) => {
          if (!brand.name) return false
          return brand.name.toLowerCase() === selectedBrand.toLowerCase()
        })
      })
    }

    const vehicleList = makeSelected.map((brandName, index) => {
      const filteredBrand = filteredBrands[index]
      const modelName = [modelo1, modelo2, modelo3][index]
      const versionName = [versao1, versao2, versao3][index]
      let modelList = null
      let versionList = null
      if (filteredBrand && filteredBrand.items) {
        modelList = filteredBrand.items
        const model = modelList.find((model = {}) => {
          if (!model.name) return false
          return model.name.toLowerCase() === modelName.toLowerCase()
        })
        versionList = model && model.items ? model.items : null
      }

      return {
        name: brandName,
        model: modelName,
        version: versionName,
        modelList,
        versionList,
      };
    });

    let _locationSelected = 'estoque'
    if (this.props.filterCustom && this.props.filterCustom.Location) {
      this.props.filterCustom &&
        this.props.filterCustom.Location.map(item => {
          if (!item.Cidade) _locationSelected = item.Estado
          else _locationSelected = `${item.Cidade} - ${item.Abbr}`
        })
    }

    const { versionList } = vehicleList[openedVersion]
    const renderList = versionList && versionList.length > 0

    if (
      (renderList && versionsOpen) ||
      (renderList &&
        this.props.initialFilters.marca !== undefined &&
        this.props.initialFilters.marca !== '' &&
        this.props.initialFilters.modelo !== undefined &&
        this.props.initialFilters.modelo !== '')
    ) {
      const { name, model } = vehicleList[openedVersion]
      let result = sortArrayAlphabeticallyByObjKey(versionList, 'name')
      let modelVersions = []
      let modelVersionsPriority = []
      for (let i = 0; i < result.length; i++) {
        if (result[i].count) {
          if (
            (this.state.versionInputValue &&
              !!~result[i].name
                .trim()
                .toLowerCase()
                .indexOf(this.state.versionInputValue.trim().toLowerCase())) ||
            !this.state.versionInputValue
          ) {
            let thisVersion = (
              <a
                key={`filtersModelVersions${i}${cleanString(result[i].name, {
                  toLowerCase: 1,
                  removeAccents: 1,
                  removeDots: 1,
                  slugify: 1,
                })}
              `}
                className="Filters__line Filters__line__result"
                onClick={this.handleAddVersion.bind(this, result[i].name)}
                href={this.getUrlFilter(
                  _locationSelected,
                  name,
                  model,
                  result[i].name
                )}
              >
                {result[i].name}
              </a>
            )
            if (
              this.state.versionInputValue &&
              new RegExp(
                '^' + this.state.versionInputValue.trim().toLowerCase()
              ).test(result[i].name.trim().toLowerCase())
            ) {
              modelVersionsPriority.push(thisVersion)
            } else {
              modelVersions.push(thisVersion)
            }
          }
        }
      }
      if (modelVersionsPriority.length || modelVersions.length) {
        return modelVersionsPriority.concat(modelVersions)
      } else {
        return (
          <div className="Filters__line Filters__line__result Filters__line__result__error">
            Nenhum resultado
          </div>
        )
      }
    }
  }
  renderModels() {
    return (
      <Slide isOpen={this.state.modelsOpen} position={'Left'}>
        <FilterContainer title="Modelo">
          {this.renderModelsBack()}
          <FilterGroup noBorder={true}>
            <Input
              label="Digite o modelo desejado"
              type="text"
              value={this.state.modelInputValue}
              onChange={e => {
                this.setState({ modelInputValue: e.target.value })
              }}
              dontShowError={true}
              tabIndex="-1"
            />
          </FilterGroup>
          <FilterGroup title="Todos os Modelos">
            {this.renderModelsList()}
          </FilterGroup>
        </FilterContainer>
      </Slide>
    )
  }
  getObjectFilter(nameFilter) {
    let _versionList = this.state.versionsOpen ? this.state.versionsOpen : 1
    let _list = this.props.allFilters.filter(item => {
      return item.name == nameFilter
    })
    _list = _list.length && _list[0].items ? _list[0].items : []
    return _list
  }
  renderModelsBack() {
    return (
      <div
        className="Filters__back"
        onClick={this.handleToggleModels.bind(this, false)}
      ></div>
    )
  }
  renderModelsList() {
    const { modelsOpen, filters } = this.state
    const type = filters.tipoveiculo
    let _modelList = modelsOpen ? modelsOpen : 1
    const { marca1, marca2, marca3 } = filters[type]
    const _makeSelected = [marca1, marca2, marca3].filter(Boolean)

    let _list = this.props.allFilters.length
      ? this.getObjectFilter('Make').filter((item = {}) => {
        if (!item.name || !_makeSelected[_modelList - 1]) return false
        return item.name.toLowerCase() == _makeSelected[_modelList - 1].toLowerCase()
      })
    : []

    let _locationSelected = 'estoque'

    if (this.props.filterCustom && this.props.filterCustom.Location) {
      this.props.filterCustom &&
        this.props.filterCustom.Location.map(item => {
          if (!item.Cidade) _locationSelected = item.Estado
          else _locationSelected = `${item.Cidade} - ${item.Abbr}`
        })
    }

    if (_list.length && _list[0].items) {
      _list = _list[0].items
    }

    const renderList = _modelList && _list && _list.length

    if (
      (renderList && this.state.modelsOpen) ||
      (renderList &&
        this.props.initialFilters &&
        this.props.initialFilters.marca !== undefined &&
        this.props.initialFilters.marca !== '' &&
        this.props.initialFilters.modelo !== undefined &&
        this.props.initialFilters.modelo === '')
    ) {
      let result = sortArrayAlphabeticallyByObjKey(_list, 'name')
      let makeModels = []
      let makeModelsPriority = []

      for (let i = 0; i < result.length; i++) {
        if (result[i].count) {
          if (
            (this.state.modelInputValue &&
              !!~result[i].name
                .trim()
                .toLowerCase()
                .indexOf(this.state.modelInputValue.trim().toLowerCase())) ||
            !this.state.modelInputValue
          ) {
            let makeModel = (
              <a
                key={
                  'filtersMakeModels' +
                  i +
                  cleanString(result[i].name, {
                    toLowerCase: 1,
                    removeAccents: 1,
                    removeDots: 1,
                    slugify: 1,
                  })
                }
                className="Filters__line Filters__line__result"
                onClick={this.handleAddModel.bind(this, result[i].name)}
                href={this.getUrlFilter(
                  _locationSelected,
                  _makeSelected[_modelList - 1],
                  result[i].name
                )}
              >
                {result[i].name}
              </a>
            )
            if (
              this.state.makeInputValue &&
              new RegExp(
                '^' + this.state.makeInputValue.trim().toLowerCase()
              ).test(result[i].name.trim().toLowerCase())
            ) {
              makeModelsPriority.push(makeModel)
            } else {
              makeModels.push(makeModel)
            }
          }
        }
      }
      if (makeModelsPriority.length || makeModels.length) {
        return makeModelsPriority.concat(makeModels)
      } else {
        return (
          <div className="Filters__line Filters__line__result Filters__line__result__error">
            Nenhum resultado
          </div>
        )
      }
    }
  }
  renderAddMake() {
    if (
      (!this.state.filters[this.state.filters.tipoveiculo].marca1 &&
        !this.state.filters[this.state.filters.tipoveiculo].marca2 &&
        !this.state.filters[this.state.filters.tipoveiculo].marca3) ||
      this.state.makesCardsOpen
    ) {
      return (
        <Fragment>
          {this.state.filters.tipoveiculo == VEHICLE_TYPE.car
            ? this.renderMakesCards()
            : this.renderMakesBikesCards()}
          {this.getObjectFilter('Make').length ? (
            <div
              data-qa="filter_see_all_makes"
              onClick={this.handleToggleAllMakes.bind(this, true)}
              className="Filters__line Filters__line__see-more Filters__line--icon Filters__line--icon--right Filters__line--right"
            >
              Ver todas as marcas
            </div>
          ) : undefined}
        </Fragment>
      )
    } else if (
      !this.state.filters[this.state.filters.tipoveiculo].marca2 ||
      !this.state.filters[this.state.filters.tipoveiculo].marca3
    ) {
      return (
        <div
          onClick={() => {
            this.setState({ makesCardsOpen: true })
          }}
          className="Filters__line Filters__line--add-vehicle Filters__line--icon Filters__line--icon--plus"
        >
          Adicione mais um veículo
        </div>
      )
    }
    return false
  }
  renderMakeBlock(index) {
    let type = this.state.filters.tipoveiculo
    if (index && this.state.filters[type]['marca' + index]) {
      let _make = this.state.filters[type]['marca' + index]
      return (
        <div className="Filters__make-block">
          <div className="Filters__make-block__logo">
            {type == VEHICLE_TYPE.car ? (
              <img src={this.renderMakeLogo(_make)} />
            ) : (
              <img src={this.renderMakeBikeLogo(_make)} />
            )}
          </div>
          <div>
            <div
              className="Filters__line Filters__line--uppercase Filters__line--make Filters__line--icon Filters__line--icon--close"
              onClick={() => this.handleRemoveMake(_make, index)}
            >
              {_make}
            </div>
            {this.state.filters[type]['modelo' + index] ? (
              <div
                className="Filters__line Filters__line--uppercase Filters__line--strong  Filters__line--icon Filters__line--icon--close"
                onClick={() => {
                  setTimeout(() => {
                    this.handleFilterChange('modelo' + index, '', type)
                    this.handleFilterChange('versao' + index, '', type)
                  }, 0)
                }}
              >
                {this.state.filters[type]['modelo' + index]}
              </div>
            ) : (
              <div
                className="Filters__line Filters__line--gray Filters__line--icon Filters__line--icon--right"
                onClick={this.handleToggleModels.bind(this, index)}
              >
                Todos os modelos
              </div>
            )}
            {type == VEHICLE_TYPE.car ? (
              this.state.filters[type]['versao' + index] ? (
                <div
                  className={
                    'Filters__line  Filters__line--uppercase Filters__line--strong  Filters__line--icon Filters__line--icon--close'
                  }
                  onClick={() => this.handleFilterChange('versao' + index, '')}
                >
                  {this.state.filters[type]['versao' + index]}
                </div>
              ) : (
                <div
                  className={
                    'Filters__line Filters__line--icon Filters__line--icon Filters__line--icon--right' +
                    (!this.state.filters[type]['modelo' + index]
                      ? ' Filters__line--disabled'
                      : ' Filters__line--gray')
                  }
                  onClick={this.handleToggleVersions.bind(this, index)}
                >
                  Todas as versões
                </div>
              )
            ) : (
              false
            )}
          </div>
        </div>
      )
    }
  }
  renderCurrentMakes() {
    return (
      <Fragment>
        {this.renderMakeBlock('1')}
        {this.renderMakeBlock('2')}
        {this.renderMakeBlock('3')}
      </Fragment>
    )
  }
  renderMakeLogo(make) {
    return (
      config.urlImgS3 +
      'img/logos/carro/' +
      cleanString(make, { toLowerCase: 1, removeAccents: 1, wordOnly: 1 }) +
      '.webp?s=fill&w=72&h=72&q=80&t=true&z=' +
      config.randomUrl
    )
  }
  renderMakeBikeLogo(make) {
    return (
      config.urlImgS3 +
      'img/logos/moto/' +
      cleanString(make, { toLowerCase: 1, removeAccents: 1, wordOnly: 1 }) +
      '.webp?s=fill&w=144&h=144&q=80&t=true&z=' +
      config.randomUrl
    )
  }
  checkAvailableMakes(makes) {
    let _makes = this.getObjectFilter('Make')
    _makes = _makes.filter(item => {
      return item.name.toLowerCase() == makes
    })

    if (_makes.length) return false
    return true
  }
  renderMakesCards() {
    if (onClientSide()) {
      let makes = [
        'Chevrolet',
        'Fiat',
        'Ford',
        'Honda',
        'Hyundai',
        'Mitsubishi',
        'Renault',
        'Toyota',
        'Volkswagen',
      ]
      let cards = []
      for (let i = 0; i < makes.length; i++) {
        const make = cleanString(makes[i], {
          toLowerCase: 1,
          removeAccents: 1,
          removeDots: 1,
          slugify: 1,
        })
        cards.push(
          <CardMake
            dataQA={`filter_make_card_${make}`}
            key={`filtersMakeCard-${i}-${make}`}
            make={make}
            img={this.renderMakeLogo(makes[i])}
            checked={false}
            disabled={this.checkAvailableMakes(makes[i].toLowerCase())}
            onClick={this.handleAddMake.bind(this, makes[i].toUpperCase())}
            url={this.getUrlFilter(this.state.locationCardMake, makes[i])}
          >
            {this.props.children}
          </CardMake>
        )
      }
      if (cards.length) {
        return <CarouselContainer>{cards}</CarouselContainer>
      }
    }
    return false
  }
  renderMakesBikesCards() {
    if (onClientSide()) {
      let makes = [
        'Bmw',
        'Dafra',
        'Ducati',
        'Harley-Davidson',
        'Honda',
        'Kasinski',
        'Kawasaki',
        'Suzuki',
        'Yamaha',
      ]
      let cards = []
      for (let i = 0; i < makes.length; i++) {
        const make = cleanString(makes[i], {
          toLowerCase: 1,
          removeAccents: 1,
          removeDots: 1,
          slugify: 1,
        })
        cards.push(
          <CardMake
            dataQA={`filter_make_card_${make}`}
            key={`filtersMakeCard-${i}-${make}`}
            make={make}
            img={this.renderMakeBikeLogo(makes[i])}
            checked={false}
            disabled={this.checkAvailableMakes(makes[i].toLowerCase())}
            onClick={this.handleAddMake.bind(this, makes[i].toUpperCase())}
            url={this.getUrlFilter(this.state.locationCardMake, makes[i])}
          >
            {this.props.children}
          </CardMake>
        )
      }
      if (cards.length) {
        return <CarouselContainer>{cards}</CarouselContainer>
      }
    }
    return false
  }
  renderAllMakes() {
    return (
      <Slide isOpen={this.state.makesOpen} position={'Left'}>
        <FilterContainer title="Todas as Marcas">
          {this.renderMakesBack()}
          <FilterGroup noBorder={true}>
            <Input
              dataQA="input_make_search"
              label="Digite a marca desejada"
              type="text"
              value={this.state.makeInputValue}
              onChange={e => {
                this.setState({ makeInputValue: e.target.value })
              }}
              dontShowError={true}
            />
          </FilterGroup>
          <FilterGroup title="Todas as Marcas" noBorder={true}>
            {this.renderAllMakesList()}
          </FilterGroup>
        </FilterContainer>
      </Slide>
    )
  }
  renderAllMakesList() {
    let _listMakes = this.getObjectFilter('Make')

    let _locationSelected = 'estoque'
    if (this.props.filterCustom && this.props.filterCustom.Location) {
      this.props.filterCustom &&
        this.props.filterCustom.Location.map(item => {
          if (!item.Cidade) _locationSelected = item.Estado
          else _locationSelected = `${item.Cidade} - ${item.Abbr}`
        })
    }

    if (this.state.locationCardMake != _locationSelected)
      this.setState({ locationCardMake: _locationSelected })

    const renderList = _listMakes && _listMakes.length

    if (
      (renderList && this.state.makesOpen) ||
      (renderList &&
        this.props.initialFilters &&
        this.props.initialFilters.marca !== undefined &&
        this.props.initialFilters.marca === '')
    ) {
      let result = sortArrayAlphabeticallyByObjKey(_listMakes, 'name')
      let makeModels = []
      let makeModelsPriority = []
      for (let i = 0; i < result.length; i++) {
        if (result[i].count) {
          if (
            (this.state.makeInputValue &&
              !!~result[i].name
                .trim()
                .toLowerCase()
                .indexOf(this.state.makeInputValue.trim().toLowerCase())) ||
            !this.state.makeInputValue
          ) {
            const name = cleanString(result[i].name, {
              toLowerCase: 1,
              removeAccents: 1,
              removeDots: 1,
              slugify: 1,
            })
            let makeModel = (
              <a
                data-qa={`filter_make_item_${name}`}
                onClick={this.handleAddMake.bind(this, result[i].name)}
                key={`filtersAllMakes-${i}-${name}`}
                className="Filters__line Filters__line__result"
                href={this.getUrlFilter(_locationSelected, result[i].name)}
              >
                {result[i].name}
              </a>
            )
            if (
              this.state.makeInputValue &&
              new RegExp(
                '^' + this.state.makeInputValue.trim().toLowerCase()
              ).test(result[i].name.trim().toLowerCase())
            ) {
              makeModelsPriority.push(makeModel)
            } else {
              makeModels.push(makeModel)
            }
          }
        }
      }
      if (makeModelsPriority.length || makeModels.length) {
        return makeModelsPriority.concat(makeModels)
      } else {
        return (
          <div className="Filters__line Filters__line__result Filters__line__result__error">
            Nenhum resultado
          </div>
        )
      }
    }
  }
  getUrlFilter(location, make, model, version) {
    const _vehicleType =
      this.state.filters.tipoveiculo == 'car' ? 'carros' : 'motos'
    const _location = `/${generateLocationLeftHand(location)}`
    const _make = make
      ? `/${cleanString(make, {
          toLowerCase: 1,
          removeAccents: 1,
          removeDots: 1,
          slugify: 1,
        })}`
      : ''
    const _model = model
      ? `/${cleanString(model, {
          toLowerCase: 1,
          removeAccents: 1,
          removeDots: 1,
          slugify: 1,
        })}`
      : ''
    const _version = version
      ? `/${cleanString(version, {
          toLowerCase: 1,
          removeAccents: 1,
          removeDots: 1,
          slugify: 1,
        })}`
      : ''
    const _anoDe =
      this.props.filterCustom && this.props.filterCustom.AnoDe
        ? `/de.${parseInt(this.props.filterCustom.AnoDe)}`
        : ''
    const _anoAte =
      this.props.filterCustom && this.props.filterCustom.AnoAte
        ? `/ate.${parseInt(this.props.filterCustom.AnoAte)}`
        : ''

    return `${config.urlApp}${_vehicleType}${_location}${_make}${_model}${_version}${_anoDe}${_anoAte}`
  }
  renderMakesBack() {
    return (
      <div
        data-qa="filter_makes_go_back"
        className="Filters__back"
        onClick={this.handleToggleAllMakes.bind(this, false)}
      >
        <div className={'Filters__back__icon Filters__back__icon--1'}></div>
        <div className={'Filters__back__icon Filters__back__icon--2'}></div>
      </div>
    )
  }
  handleOpen(state, who) {
    if (who === 'select') {
      return this.setState({
        ['slideLeftOpen' + this.state.whoIsOpen]: false,
        whoIsOpen: 0,
        showSelect: false,
      })
    }
    if (!who) {
      return this.setState({
        slideLeftOpen: state,
        showSelect: state,
        whoIsOpen: who,
      })
    }
    this.setState({
      ['slideLeftOpen' + who]: state,
      showSelect: state,
      whoIsOpen: who,
      slideLeftOpen: state,
    })
  }
  renderWithPhoto() {
    return (
      <FilterGroup>
        <div className="Form__InputRow">
          <div className="Form__field">
            <Input
              dataQA="toggle_filter_photo"
              type="toggle"
              label="Apenas anúncios com foto"
              checked={this.state.filters[this.state.filters.tipoveiculo].media}
              onChange={() => {
                this.handleFilterChange(
                  'media',
                  this.state.filters[this.state.filters.tipoveiculo].media
                    ? ''
                    : 'com fotos'
                )
              }}
            />
          </div>
        </div>
      </FilterGroup>
    )
  }
  clearAllNewFiltersUrl() {
    const initialState = {
      carDelivery: false,
      trocaComTroco: false,
      videoChamada: false,
      'visão360°': false,
      vistoriado: false
    }
    const search = window.location.search
    .replace(/&?Oportunidades=|Super%20Preco|Car%20Delivery|Troca%20Com%20Troco|Vis%C3%A3o360%C2%B0|Vistoriado&?|\|/g, '');

    const finalUrl = search + buildOportunitiesUrl(initialState)

    this.props.history.push({ search: finalUrl })
  }
  cleanAllFilters() {
    if(onClientSide()){
      sendDispatchEvent("limparfiltros")
      window.sessionStorage.setItem('shouldNotForceLocation', true)
    }

    let type = this.state.filters.tipoveiculo
    let newFilters = JSON.parse(JSON.stringify(this.state.filters))
    newFilters[type] = emptyFilters[type]

    delete newFilters.estadocidade
    this.setState({ locationInputValue: '', filters: newFilters })
    this.refs.parentScrollContainer &&
      (this.refs.parentScrollContainer.scrollTop = 0)
    this.props.dispatch({ type: '@filter/RESET' })
    this.clearAllNewFiltersUrl()
  }
  renderArmoured() {
    return (
      <FilterGroup title={'Blindagem'}>
        <div className="Form__InputRow">
          <label data-qa="filter_armoured_yes" className="Checkbox">
            <input
              type="checkbox"
              name="sim"
              id="sim"
              checked={this.state.filters['car'].blindado.includes(
                'com blindagem'
              )}
              className="Form__TextInput"
              onChange={event => {
                this.handleFilterChange('blindado', 'com blindagem')
              }}
              placeholder="Selecione a blindagem"
            />
            {'Sim'}
          </label>
          <label data-qa="filter_armoured_no" className="Checkbox">
            <input
              type="checkbox"
              name="nao"
              id="nao"
              checked={this.state.filters['car'].blindado.includes(
                'sem blindagem'
              )}
              className="Form__TextInput"
              onChange={event => {
                this.handleFilterChange('blindado', 'sem blindagem')
              }}
              placeholder="Selecione a blindagem"
            />
            {'Não'}
          </label>
        </div>
      </FilterGroup>
    )
  }
  resetNewFilters = () => {
    this.props.dispatch({ type: '@filter/RESET' })
  }

  compareUrlToSelectedFilters() {
    let filterSubmit = this.handleFilterSubmit()

    let hotDeal
    let hotDealFromUrl

    let category
    let categoryFromUrl

    filterSubmit = filterSubmit.split('/')

    // ofertas e feirões?
    if (
      !/^(carros|carros-usados|carros-novos|motos|motos-usadas|motos-novas)$/.test(
        filterSubmit[0]
      )
    ) {
      if (filterSubmit[0] == 'ofertas' && filterSubmit[1] == 'feiroes') {
        let _object = this.props.hotDeal.result.find(
          x => x.URL == filterSubmit[2]
        )

        if (_object && _object.Name) {
          hotDeal = _object.Name
        }

        filterSubmit.splice(0, 3)
      } else if (this.props.match.params.vehicleCategory) {
        category = filterSubmit.shift()
        if (this.props.categories.fetched && this.props.categories.result) {
          let _object = this.props.categories.result.find(
            x => x.Url.toLowerCase().trim() == category.toLowerCase().trim()
          )
          if (_object && _object.Nome) {
            category = _object.Nome
          }
        }
      }
    }

    if (this.props.match.params.hotDeal) {
      let _object = this.props.hotDeal.result.find(
        x => x.URL == this.props.match.params.hotDeal
      )
      if (_object && _object.Name) {
        hotDealFromUrl = _object.Name
      }
    } else if (this.props.match.params.vehicleCategory) {
      categoryFromUrl = this.props.match.params.vehicleCategory
      if (this.props.categories.fetched && this.props.categories.result) {
        let _object = this.props.categories.result.find(
          x =>
            x.Url.toLowerCase().trim() == categoryFromUrl.toLowerCase().trim()
        )
        if (_object && _object.Nome) {
          categoryFromUrl = _object.Nome
        }
      }
    }

    let tipoveiculo = filterSubmit.shift()

    filterSubmit = filterSubmit.join('/')

    filterSubmit = filterSubmit.split('?')

    /**
     * [estoque, tipoveiculo=carros-novos]
     */

    let filters = parseSearchFilters(
      filterSubmit[0],
      filterSubmit[1] ? filterSubmit[1] : '',
      tipoveiculo,
      category,
      hotDeal
    )

    let filtersFromUrl = parseSearchFilters(
      this.props.match.params.filters,
      this.props.location.search,
      this.props.match.params.vehicleType,
      categoryFromUrl,
      hotDealFromUrl
    )

    if (filters.estadocidade || filters.estadocidade === 'false') {
      filters.estadocidade = generateLocationLeftHand(
        generateFilterLocationFromCookie(
          decodeURIComponent(filters.estadocidade)
        )
      )
    }

    if (filters.marca1) {
      filters.marca1 = cleanString(decodeURIComponent(filters.marca1), {
        toLowerCase: 1,
        removeAccents: 1,
        removeSpecial: 1,
        slugify: 1,
      })
    }

    if (filters.modelo1) {
      filters.modelo1 = cleanString(decodeURIComponent(filters.modelo1), {
        toLowerCase: 1,
        removeAccents: 1,
        removeSpecial: 1,
        slugify: 1,
      })
    }

    if (filters.versao1) {
      filters.versao1 = cleanString(decodeURIComponent(filters.versao1), {
        toLowerCase: 1,
        removeAccents: 1,
        removeDots: 1,
        slugify: 1,
      })
    }

    if (filtersFromUrl.estadocidade) {
      filtersFromUrl.estadocidade = generateLocationLeftHand(
        generateFilterLocationFromCookie(
          decodeURIComponent(filtersFromUrl.estadocidade)
        )
      )
    }

    if (filtersFromUrl.marca1) {
      filtersFromUrl.marca1 = cleanString(
        decodeURIComponent(filtersFromUrl.marca1),
        { toLowerCase: 1, removeAccents: 1, removeSpecial: 1, slugify: 1 }
      )
    }

    if (filtersFromUrl.modelo1) {
      filtersFromUrl.modelo1 = cleanString(
        decodeURIComponent(filtersFromUrl.modelo1),
        { toLowerCase: 1, removeAccents: 1, removeSpecial: 1, slugify: 1 }
      )
    }

    if (filtersFromUrl.versao1) {
      filtersFromUrl.versao1 = cleanString(
        decodeURIComponent(filtersFromUrl.versao1),
        { toLowerCase: 1, removeAccents: 1, removeDots: 1, slugify: 1 }
      )
    }

    if (!filtersFromUrl.estadocidade) {
      filtersFromUrl.estadocidade = 'estoque'
    }

    if (!filtersFromUrl.tipoveiculo) {
      filtersFromUrl.tipoveiculo = 'carros'
    }

    return (
      decodeURIComponent(
        JSON.stringify(orderObjectKeys(filtersFromUrl)).toLowerCase()
      ) !=
      decodeURIComponent(JSON.stringify(orderObjectKeys(filters)).toLowerCase())
    )
  }

  render() {
    return (
      <div className={'Search-result Search-result--container-left'}>
        <div
          className={'Filters__container__scroll'}
          ref="parentScrollContainer"
        >
          <FilterContainer>
            <NavBar type="tabs" resetNewFilters={this.resetNewFilters}>
              <NavItem
                dataQA="filter_cars"
                navTitle="Carros"
                default={!!(this.state.filters.tipoveiculo == VEHICLE_TYPE.car)}
                onClick={this.handleVehicleTypeChange.bind(
                  this,
                  VEHICLE_TYPE.car
                )}
              >
                {this.renderFilters()}
              </NavItem>
              <NavItem
                dataQA="filter_bikes"
                navTitle="Motos"
                default={
                  !!(this.state.filters.tipoveiculo == VEHICLE_TYPE.bike)
                }
                onClick={this.handleVehicleTypeChange.bind(
                  this,
                  VEHICLE_TYPE.bike
                )}
              >
                {this.renderFilters()}
              </NavItem>
            </NavBar>
          </FilterContainer>
          {this.props.allFilters.length > 0 ? (
            <Fragment>
              {this.renderVersions()}
              {this.renderModels()}
              {this.renderAllMakes()}
              {this.state.filters.tipoveiculo == VEHICLE_TYPE.bike
                ? this.renderCylinderCapacity()
                : ''}
              {this.renderSeller()}
              {this.state.filters.tipoveiculo == VEHICLE_TYPE.bike
                ? this.renderCoolingType()
                : ''}
              {this.state.filters.tipoveiculo == VEHICLE_TYPE.bike
                ? this.renderIgnition()
                : ''}
              {this.state.filters.tipoveiculo == VEHICLE_TYPE.bike
                ? this.renderEngine()
                : ''}
              {this.renderOptionals()}
              {this.state.filters.tipoveiculo == VEHICLE_TYPE.car
                ? this.renderGearshifts()
                : this.renderShifts()}
              {this.state.filters.tipoveiculo == VEHICLE_TYPE.car
                ? this.renderFuels()
                : ''}
              {this.state.filters.tipoveiculo == VEHICLE_TYPE.car
                ? this.renderFinalPlate()
                : this.renderBrake()}
              {this.state.filters.tipoveiculo == VEHICLE_TYPE.car
                ? this.renderArmoured()
                : this.renderCharge()}
              {this.renderColors()}
              {this.state.filters.tipoveiculo == VEHICLE_TYPE.bike
                ? this.renderSecondaryColor()
                : ''}
              {this.renderBodyType()}
              {this.renderNeed()}
              {!this.shouldShowOffersOnTop() && this.renderHotDeal()}
              {this.renderAttributes()}
              {this.renderWithPhoto()}
              {
                <FilterGroup>
                  <Button
                    dataQA="clean_all_filters"
                    noAction={true}
                    onClick={this.cleanAllFilters.bind(this)}
                    className="Button Filters__advanced-button Filters__limpar-filtros"
                    id="limparfiltros"
                  >
                    Limpar filtros
                  </Button>
                </FilterGroup>
              }
            </Fragment>
          ) : (
            []
          )}
        </div>
        {this.props.allFilters.length > 0 &&
        <div className="Filters__clear-filters-container">
            <button
              onClick={this.cleanAllFilters.bind(this)}
              dataQA="clean_all_filters"
              id="limparfiltros"
            >
              Limpar
            </button>
          </div>
          }
      </div>
    )
  }
}

export default withCookieNotice(
  connect(store => {
    return {
      categories: store.categoriesState,
      filtersModels: store.filtersModelsState,
      filtersVersions: store.filtersVersionsState,
      filtersCarLocation: store.filtersCarLocationState,
      filtersBikeLocation: store.filtersBikeLocationState,
      hotDeal: store.hotDealState,
      geolocation: store.geolocationState,
      filtersFuel: store.filtersFuelState,
      searchResult: store.searchResultState,
      newFilters: store.filters,
      fairs: store.fairs,
    }
  })(Filters)
)
